import type { InputProps } from '../input-props'
import { JalaliDatePicker } from './jalali-date-picker'

export function DateTimeInput({ field, value, onChange, onBlur, disabled, invalid }: InputProps) {
  const calendarMode = (field.type_config?.calendar_mode as 'jalali' | 'gregorian' | undefined) ?? 'jalali'
  return (
    <JalaliDatePicker
      mode="datetime"
      calendarMode={calendarMode}
      value={(value as string) ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      invalid={invalid}
    />
  )
}
